module.exports = __webpack_public_path__ + "img/ppr-works-buttons-add.ac245063.svg";